export const TipoDato = Object.freeze({
    CODIGO: Symbol(),
    CADENA: Symbol(),
    CANTIDAD: Symbol(),
    IMPORTE: Symbol(),
    FECHA: Symbol(),
    NUMERO: Symbol()
})


export const NivelAcceso = Object.freeze({
    VER: 1,
    AGREGAR: 2,
    EDITAR: 3,
    BORRAR_REINSERTAR: 4,
    CONTROLAR_TODO: 5
})

export const FormatoFechaHora = Object.freeze({
    ARGENTINA: 'DD/MM/YYYY HH:mm:ss'
})

export const Acciones = Object.freeze({
    ADD: 'TXT_AGREGAR',
    EDIT: 'TXT_EDITAR',
    DEL: 'TXT_BORRAR',
    SEE: 'TXT_VER',
    REAC: 'TXT_REACTIVAR'
})

export const EstadoFormulario = Object.freeze({
    PREPARADO: Symbol(),
    CON_ERRORES: Symbol(),
    CARGANDO: Symbol()
})

export const CajaMotivosMovimiento = Object.freeze({
    VENTA_POR_CAJA: 'adce7003-be0e-4f95-93f6-39b1e2ee5c16',
    COBRO_EN_MESA: '07a8f62d-8b23-4583-83f1-c2fac73a5373',
    COBRO_POR_CTA_CTE: '6f51138b-8d06-488c-96c8-b0b457f3cd02',
})

export const CajaFormasDePago = Object.freeze({
    CUENTA_CORRIENTE: '7cc0996d-f45c-4840-a65b-103dab99ff07',
    EFECTIVO: '0cde080a-8185-4fec-b525-555a337187c1'
})